import {forwardRef, HTMLAttributes} from 'react'
import {
    StyledInputTaxCode,
    StyledFormGridSection,
    StyledFormGridSectionItem,
    StyledFormGridSectionSubTitle,
    StyledFormGridSectionTitle,
    StyledFormGridTitle,
    StyledGenerateTaxCodeButton,
    StyledFormCardSection,
    StyledFormAddressHint,
    StyledFormFieldBox,
    StyledLimitExpandContainer
} from './style'
import {InputTextProps} from '@/components/commons/input-text/InputText'
import {ButtonProps} from '@/components/ui/button/Button'
import {GridItemProps, GridProps} from '@/components/ui/grid-atoms/GridAtoms'
import {Flexbox, FlexboxProps} from '@/components/ui/flexbox/FlexBox'
import {InputHelpText} from '../input-help-text/InputHelpText'
import {useTranslation} from '@/translations/i18n'

/**
 * @deprecated use @/components/commons/FormSection.tsx instead
 * */
export const FormGridSection = (props: HTMLAttributes<HTMLDivElement>) => <StyledFormGridSection {...props} />
export const FormGridSectionItem = (props: HTMLAttributes<HTMLDivElement>) => <StyledFormGridSectionItem {...props} />
export const FormGridSectionTitle = (props: HTMLAttributes<HTMLHeadingElement>) => (
    <StyledFormGridSectionTitle {...props} />
)

export const FormGridTitle = (props: HTMLAttributes<HTMLHeadingElement>) => <StyledFormGridTitle {...props} />
export const FormGridSectionSubTitle = (props: HTMLAttributes<HTMLParagraphElement>) => (
    <StyledFormGridSectionSubTitle {...props} />
)

export const InputTaxCode = forwardRef<HTMLInputElement, InputTextProps>((props, ref) => (
    <StyledInputTaxCode {...props} ref={ref} />
))
export const GenerateTaxCodeButton = (props: ButtonProps) => <StyledGenerateTaxCodeButton {...props} />

// todo: move to details atoms and rename to DetailsCardSection
export const FormCardSection = ({padding, ...props}: GridProps & {padding?: number}) => (
    <StyledFormCardSection {...props} $padding={padding} />
)
export const FormAddressHint = (props: FlexboxProps<'div'>) => <StyledFormAddressHint {...props} />

export const FormFieldBox = ({
    hasError,
    isSelected,
    isDisabled,
    fitContent,
    ...props
}: GridItemProps & {isSelected?: boolean; hasError?: boolean; isDisabled?: boolean; fitContent?: boolean}) => (
    <StyledFormFieldBox
        role="button"
        {...props}
        $isSelected={isSelected}
        $isDisabled={isDisabled}
        $hasError={hasError}
        $fitContent={fitContent}
    />
)

interface FormInputTxtCounterProps {
    limit?: number
    count: number
    errorMessage?: string
}

export const FormInputTxtCounter = ({limit, count, errorMessage}: FormInputTxtCounterProps) => {
    const {t} = useTranslation()
    return (
        <Flexbox justify="space-between" fullWidth>
            {errorMessage && <InputHelpText error={errorMessage} />}
            <StyledLimitExpandContainer justify="flex-end" align="center" gap={2}>
                {limit && <InputHelpText helpText={t('medical_records:characters_counter', {limit, count})} />}
            </StyledLimitExpandContainer>
        </Flexbox>
    )
}
